import { TMessage } from "../../i18n/tt";

export enum FilterKeys {
  ALL_TRANSACTIONS = "allTransactions",
  TRANSFER = "transfer",
  ISSUE = "issueOrIncrease",
  SPLIT = "split",
  CAPITAL_REDUCTION = "reduction-capital",
  DIVIDEND = "dividend",
}

export enum TransactionType {
  AUTOIMPORT = "AUTOIMPORT",
  ISSUE = "ISSUE",
  INCORPORATION = "INCORPORATION",
  BUY_SELL = "BUY_SELL",
  GIFT = "GIFT",
  INHERITANCE = "INHERITANCE",
  OTHER_TRANSFER = "OTHER_TRANSFER",
  SPLIT = "SPLIT",
  REVERSE_SPLIT = "REVERSE_SPLIT",
  INCREASE_NOMINAL_VALUE = "INCREASE_NOMINAL_VALUE",
  CANCELLATION_OF_SHARES = "CANCELLATION_OF_SHARES",
  REDUCTION_NOMINAL_VALUE = "REDUCTION_NOMINAL_VALUE",
  PAY_DIVIDEND = "PAY_DIVIDEND",
  GROUP_CONTRIBUTION = "GROUP_CONTRIBUTION",
  CONVERSION_OF_SHARES = "CONVERSION_OF_SHARES",
  CONVERSION_FROM_ISIN = "CONVERSION_FROM_ISIN",
  SHAREHOLDING_PER_DATE = "SHAREHOLDING_PER_DATE",
  LIQUIDATION = "LIQUIDATION",
  MERGER = "MERGER",
}

export const transactionLabel: { [key in TransactionType]: TMessage } = {
  [TransactionType.AUTOIMPORT]: { key: "AUTOIMPORT" },
  [TransactionType.ISSUE]: { key: "ISSUE" },
  [TransactionType.INCORPORATION]: { key: "INCORPORATION" },
  [TransactionType.BUY_SELL]: { key: "BUY_SELL" },
  [TransactionType.GIFT]: { key: "GIFT" },
  [TransactionType.INHERITANCE]: { key: "INHERITANCE" },
  [TransactionType.OTHER_TRANSFER]: { key: "OTHER_TRANSFER" },
  [TransactionType.SPLIT]: { key: "SPLIT" },
  [TransactionType.REVERSE_SPLIT]: { key: "REVERSE_SPLIT" },
  [TransactionType.INCREASE_NOMINAL_VALUE]: { key: "INCREASE_NOMINAL_VALUE" },
  [TransactionType.CANCELLATION_OF_SHARES]: { key: "CANCELLATION_OF_SHARES" },
  [TransactionType.REDUCTION_NOMINAL_VALUE]: { key: "REDUCTION_NOMINAL_VALUE" },
  [TransactionType.PAY_DIVIDEND]: { key: "PAY_DIVIDEND" },
  [TransactionType.GROUP_CONTRIBUTION]: { key: "GROUP_CONTRIBUTION" },
  [TransactionType.CONVERSION_OF_SHARES]: { key: "CONVERSION_OF_SHARES" },
  [TransactionType.CONVERSION_FROM_ISIN]: { key: "CONVERSION_FROM_ISIN" },
  [TransactionType.SHAREHOLDING_PER_DATE]: { key: "SHAREHOLDING_PER_DATE" },
  [TransactionType.LIQUIDATION]: { key: "LIQUIDATION" },
  [TransactionType.MERGER]: { key: "MERGER" },
};

export enum TransactionJsonType {
  ISSUE = "dcompany.dto.inbound.IssueNewSharesDTO",
  INCREASE_NOMINAL_VALUE = "dcompany.dto.inbound.IncreaseNominalValueDTO",
  SPLIT = "dcompany.dto.inbound.ShareSplitDTO",
  REVERSE_SPLIT = "dcompany.dto.inbound.ShareReverseSplitDTO",
  REDUCTION_NOMINAL_VALUE = "dcompany.dto.inbound.ReductionOfNominalValueDTO",
  CANCELLATION_OF_SHARES = "dcompany.dto.inbound.CancellationOfSharesDTO",
  PAY_DIVIDEND = "dcompany.dto.inbound.PayDividendJsonData",
  GROUP_CONTRIBUTION = "dcompany.dto.inbound.GroupContributionJsonData",
  CONVERSION_OF_SHARES = "dcompany.dto.inbound.ConversionOfSharesDTO",
  CONVERSION_FROM_ISIN = "dcompany.dto.inbound.ConversionFromISINDTO",
  SHAREHOLDING_PER_DATE = "dcompany.dto.inbound.ShareholdingPerDateDTO",
  LIQUIDATION = "dcompany.dto.inbound.LiquidationDTO",
  SHAREHOLDER_CONTRIBUTION = "dcompany.dto.inbound.ShareholderContributionDTO",
  MERGER = "dcompany.dto.inbound.MergerDTO",
}
